import type { IEnvironment } from '@/interfaces.ts'
import { Environment } from '@/enums.ts'
import { LOCAL_STORAGE_CROWDY_API_ENV_KEY } from '@/config/config.ts'

export const DEFAULT_ENVIRONMENT: Environment = import.meta.env.CROWDY_ENV as Environment
export const ENVIRONMENTS: IEnvironment[] = [
  {
    title: 'Local',
    env: Environment.Local,
    proxyTarget: 'http://localhost:8080',
    apiUrl: 'http://localhost:5174/query',
    apiBaseUrl: 'http://localhost:8080',
    wsUrl: 'ws://localhost:5174/query',
    widgetUrl: 'http://192.168.0.160:5173',
  },
  {
    title: 'Testing',
    env: Environment.Testing,
    proxyTarget: 'https://platform-testing.crowdy.ai',
    apiUrl: 'https://platform-testing.crowdy.ai/query',
    apiBaseUrl: 'https://platform-testing.crowdy.ai',
    wsUrl: 'wss://platform-testing.crowdy.ai/query',
    widgetUrl: 'https://chat-testing.crowdy.ai',
  },
  {
    title: 'Staging',
    env: Environment.Staging,
    proxyTarget: 'https://platform-staging.crowdy.ai',
    apiUrl: 'https://platform-staging.crowdy.ai/query',
    apiBaseUrl: 'https://platform-staging.crowdy.ai',
    wsUrl: 'wss://platform-staging.crowdy.ai/query',
    widgetUrl: 'https://chat-staging.crowdy.ai',
  },
  {
    title: 'Production',
    env: Environment.Production,
    proxyTarget: 'https://platform.crowdy.ai',
    apiUrl: 'https://platform.crowdy.ai/query',
    apiBaseUrl: 'https://platform.crowdy.ai',
    wsUrl: 'wss://platform.crowdy.ai/query',
    widgetUrl: 'https://chat.crowdy.ai',
  },
]
.map((env) => {
  if (import.meta.env.DEV) {
    env.apiUrl = 'http://192.168.0.160:5174/query'
    env.wsUrl = 'ws://192.168.0.160:5174/query'
  }

  return env
})
.filter(({ env }) => {
  return window.location.href.includes('https://') ? env !== Environment.Local : true
})

export function getDefaultClientEnv (): Environment {
  return localStorage.getItem(LOCAL_STORAGE_CROWDY_API_ENV_KEY) as Environment ?? DEFAULT_ENVIRONMENT
}

export function getWebsocketUrlByEnv (environment: Environment): string {
  return ENVIRONMENTS.find(({ env }) => env === environment)?.wsUrl ?? 'N/A'
}

export function getProxyTargetByEnv (environment: Environment): string {
  return ENVIRONMENTS.find(({ env }) => env === environment)?.proxyTarget ?? 'N/A'
}

export function getApiUrlByEnv (environment: Environment): string {
  return ENVIRONMENTS.find(({ env }) => env === environment)?.apiUrl ?? 'N/A'
}

export function getApiBaseUrlByEnv (environment: Environment): string {
  return ENVIRONMENTS.find(({ env }) => env === environment)?.apiBaseUrl ?? 'N/A'
}

export function getWidgetUrlByEnv (environment: Environment): string {
  return ENVIRONMENTS.find(({ env }) => env === environment)?.widgetUrl ?? 'N/A'
}

// If you want change env, do it here and for local development check also vite.config.ts
export const API_URL = getProxyTargetByEnv(DEFAULT_ENVIRONMENT)
export const API_BASE_URL = getApiBaseUrlByEnv(DEFAULT_ENVIRONMENT) // Used for loading avatars from correct env
export const API_WIDGET_URL = getWidgetUrlByEnv(DEFAULT_ENVIRONMENT) // Used in project visual settings
